const getZoomBucket = (zoom: number): number => {
  if (zoom <= 4) {
    return 4;
  } else if (zoom <= 6) {
    return 6;
  } else if (zoom <= 8) {
    return 8;
  } else if (zoom <= 12) {
    return 12;
  } else if (zoom <= 14) {
    return 14;
  }
  return 23;
};

export default getZoomBucket;
